import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { ROUTE_REORDERING } from "../app.routes";
import {
  KENDO_MENU,
  MenuAnimation,
  MenuItem,
  MenuSelectEvent,
  PopupSettings,
} from "@progress/kendo-angular-menu";
import { CustomMessagesService } from "../services/custom-messages.service";
import { MenuService } from "../services/menu.services";
import { SettingsComponent } from "../window/settings/settings.component";

@Component({
  selector: "app-header",
  imports: [KENDO_BUTTONS, KENDO_MENU, SettingsComponent],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.css",
})
export class HeaderComponent {
  protected readonly router = inject(Router);
  protected readonly customMessagesService = inject(CustomMessagesService);
  protected readonly menuService = inject(MenuService);

  public toggleDrawer(): void {
    this.menuService.requestDrawerToggle();
  }

  public swSettingsOpened = false;
  public mode: string = this.customMessagesService.translate("lectureMenu");

  public onMenuSelect(event: MenuSelectEvent): void {
    // console.log("Menu:", event.item.text);

    if (
      event.item.text === this.customMessagesService.translate("lectureMenu")
    ) {
      this.mode = event.item.text;
      void this.router.navigate(["/freeware/lecture"]);
      return;
    }

    if (
      event.item.text === this.customMessagesService.translate("reorderingMenu")
    ) {
      this.mode = event.item.text;
      void this.router.navigate(["/freeware/reordering"]);
      return;
    }

    if (event.item.text === this.customMessagesService.translate("editMenu")) {
      this.mode = event.item.text;
    }

    if (event.item.text === this.customMessagesService.translate("sauver")) {
      this.menuService.logMenuNode();
    }
  }

  public menuItems: MenuItem[] = [
    {
      text: this.customMessagesService.translate("fichier"),
      items: [
        { text: "New Folder", icon: "folder" },
        { text: "New File", icon: "file" },
        {
          text: this.customMessagesService.translate("ouvrir"),
          icon: "folder",
        },
        { separator: true },
        {
          text: this.customMessagesService.translate("pdfExport"),
          icon: "download",
        },
        { separator: true },
        {
          text: this.customMessagesService.translate("sauver"),
          icon: "save",
        },
        { separator: true },
        { text: "Properties", icon: "info-circle" },
      ],
    },
    {
      text: this.customMessagesService.translate("menu"),
      items: [
        {
          text: this.customMessagesService.translate("lectureMenu"),
          icon: "lock",
        },
        {
          text: this.customMessagesService.translate("reorderingMenu"),
          icon: "table-wizard",
        },
      ],
    },
  ];

  public animationSettings: MenuAnimation = {
    type: "slide",
    duration: 200,
  };

  public popupSettings: PopupSettings = {
    popupClass: "custom-popup",
    margin: { horizontal: 0, vertical: 0 },
  };

  protected readonly ROUTE_REORDERING = ROUTE_REORDERING;
}
